<template>
  <div>
    <van-nav-bar
      left-arrow
      title="新增农资"
      @click-left="$router.back()"
    />
    <van-form ref="form" class="form">
      <van-field v-model="form.name" :rules="rules.name" input-align="left" label="名称" />
      <wh-field-select-popup
        v-model="form.type"
        :columns="typeOptions"
        :rules="rules.type"
        label="农资类型"
      />
      <van-field :rules="rules.unit" :value="form.num" label="包装规格">
        <template #input>
          <div class="unit-box">
            <van-stepper
              v-model.number="form.num"
              :min="0"
              decimal-length="2"
              input-width="50px"
            />
            <wh-select-popup v-model="form.unit" :options="unitOptions" placeholder="单位" />
            <wh-select-popup v-model="form.pack" :options="packOptions" placeholder="单位" />
          </div>
        </template>
      </van-field>
      <van-field :rules="rules.count" :value="form.count" label="数量">
        <template #input>
          <van-stepper
            v-model.number="form.count"
            :min="0"
            input-width="80px"
          />
        </template>
      </van-field>
      <van-field :rules="rules.price" :value="form.price" label="单价(元)">
        <template #input>
          <van-stepper
            v-model="form.price"
            :decimal-length="2"
            :min="0"
            input-width="80px"
          />
        </template>
      </van-field>
      <van-field v-model="form.factory" :rules="rules.factory" input-align="left" label="生产厂家" />
      <wh-field-select-popup
        v-model="form.operator"
        :columns="operatorOptions"
        :rules="rules.operator"
        label="负责人"
      />
      <wh-field-time-popup
        v-model="form.date"
        :rules="rules.date"
        label="操作时间"
      />
    </van-form>
    <wh-sub-button @click="handleSub" />
  </div>
</template>

<script>
import { agrTypeOptions, packOptions, unitOptions } from '@/constant/common'
import api from '@/api'
import dayjs from 'dayjs'
import WhSubButton from '@/components/base/WhSubButton'
import WhFieldSelectPopup from '@/components/public/WhFieldSelectPopup/WhFieldSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhSelectPopup from '@/components/public/WhSelectPopup/WhSelectPopup'

export default {
  name: 'AgrCreate',
  components: { WhSubButton, WhFieldTimePopup, WhFieldSelectPopup, WhSelectPopup },
  data() {
    const agrDataValidator = (value, rule) => {
      return !!this.agrData
    }
    const unitValidator = (value, rule) => {
      return !!this.form.num && !!this.form.unit && !!this.form.pack
    }
    return {
      unitOptions, packOptions,
      typeOptions: [...Object.keys(agrTypeOptions).map(key => {
        return agrTypeOptions[key].label
      }), '其它农资'],
      operatorOptions: [],
      form: {
        name: '',
        factory: '',
        type: '',
        num: 0,
        unit: '',
        pack: '',
        count: 0,
        price: 0,
        date: dayjs().format('YYYY-MM-DD HH:mm:00'),
        operator: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入农资名称' }
        ],
        type: [
          { required: true, message: '请选择农资类型' }
        ],
        agrData: [
          { validator: agrDataValidator, message: '请选择农资' }
        ],
        unit: [
          { validator: unitValidator, message: '请选择完整的包装规格' }
        ],
        count: [
          { validator: val => val >= 0, message: '请输入农资数量' }
        ],
        factory: [
          { required: true, message: '请输入生产厂家' }
        ],
        operator: [
          { required: true, message: '请选择负责人' }
        ],
        date: [
          { required: true, message: '请选择时间' }
        ]
      }
    }
  },
  created() {
    this.getStaffList()
  },
  methods: {
    getStaffList() {
      api.getStaffList({ pageSize: 1000 }).then(({ data: { list }}) => {
        this.operatorOptions = list.map(i => i.name)
      })
    },
    handleSub() {
      this.$refs.form.validate().then(() => {
        const query = {
          ...this.form
        }
        query.num = query.num * 1000
        query.count = query.count * query.num
        api.createAgricultural(query).then(() => {
          this.$toast('添加成功')
          this.$router.push({ name: 'AgrList' })
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="less" scoped>
.unit-box {
  display: flex;
  flex-wrap: wrap;
}
.form {
  margin-top: 10px;
}
</style>
